import React, { Component } from 'react'
import { connect } from 'react-redux'
import { reduxForm, formValueSelector } from 'redux-form'
import * as actions from '../../actions'
import { Egreso0 } from './steps'
import { FORM_EGRESO } from '../../../../config/forms'
import { INTERVALO_CORTO } from '../../../../config/settings'
import { ToastContainer } from 'react-toastify'
import TablaPedidoCamionesEnPlayaInsatisfecho from '../../../Tablas/pedidoCamionesEnPlayaInsatisfecho/containers/TablaPedidoCamionesEnPlayaInsatisfecho'
import { Dialog } from '@material-ui/core'
import DialogoPenalizacionCamion from '../../components/DialogoPenalizacionCamion'
import DialogoDescargable from '../../components/DialogoDescargable'

import moment from 'moment'
import 'moment/locale/es'

const selector = formValueSelector(FORM_EGRESO)

class EgresoPlaya extends Component {
  constructor (props) {
    super(props)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleClose = this.handleClose.bind(this)
    this.handleCloseDescargable = this.handleCloseDescargable.bind(this)
  }

  handleSubmit () {
    this.props.egresoPlayaCpa(this.props.destroy)
  }

  handleClose () {
    this.props.showDialogoPenalizacion(false)
  }

  handleCloseDescargable (valor) {
    const {
      patenteCamion,
      patenteAcoplado
    } = this.props
    // Insertar tupla
    this.props.insertarCamionAcopladoEjes(valor, patenteCamion, patenteAcoplado)
    this.props.showDialogoDescargable(false, null, null)
  }

  render () {
    const {
      camionPenalizado,
      motivoPenalizacion,
      vencimientoPenalizacion,
      patenteCamion,
      patenteAcoplado,
      showDescargable,
      show
    } = this.props

    let vencimiento
    if (vencimientoPenalizacion) {
      vencimiento = moment(vencimientoPenalizacion).format('LLL')
    }

    return (
      <div className='camiones-abandono-container'>
        <Dialog
          open={show}
          onClose={this.handleClose}
        >
          <DialogoPenalizacionCamion camion={camionPenalizado} motivo={motivoPenalizacion} vencimiento={vencimiento} handleClose={this.handleClose} />
        </Dialog>

        <Dialog
          open={showDescargable}
          onClose={this.handleCloseDescargable}
        >
          <DialogoDescargable camion={patenteCamion} acoplado={patenteAcoplado} handleClose={this.handleCloseDescargable} />
        </Dialog>
        <h2>Egreso de Playa</h2>
        <Egreso0 onSubmit={this.handleSubmit} />
        <br />
        <TablaPedidoCamionesEnPlayaInsatisfecho />
        <ToastContainer autoClose={INTERVALO_CORTO} />
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    numero: selector(state, 'numero'),
    camionPenalizado: state.camionesIngreso.camionPenalizado,
    vencimientoPenalizacion: state.camionesIngreso.vencimientoPenalizacion,
    motivoPenalizacion: state.camionesIngreso.motivoPenalizacion,
    patenteCamion: state.camionesIngreso.patenteCamion,
    patenteAcoplado: state.camionesIngreso.patenteAcoplado,
    showDescargable: state.camionesIngreso.dialogoDescargable,
    show: state.camionesIngreso.dialogoPenalizacion
  }
}

const withRedux = connect(mapStateToProps, actions)
export default withRedux(
  reduxForm({ form: FORM_EGRESO })(EgresoPlaya)
)
